import { Component } from '@angular/core';

interface ContactCard {
    icon: string;
    title: string;
    lines: string[];
}

@Component({
    selector: 'app-contact-highlight-redesign',
    templateUrl: './contact-highlight-redesign.component.html',
    styleUrls: ['./contact-highlight-redesign.component.scss']
})
export class ContactHighlightRedesignComponent {

    title = 'Building the Future of Predictive Mental Healthcare';

    description =
        'Althea Soft exists to help healthcare institutions see risk earlier, act faster and coordinate care more effectively. By combining clinical AI, real-time monitoring and secure multidisciplinary collaboration, we support a more proactive model of mental healthcare: predictive, connected and preventive.';

    cards: ContactCard[] = [
        {
            icon: '/assets/img/redesign/about/location.svg',
            title: 'Our offices:',
            lines: [
                '35 Woodlark road',
                'Newbury',
                'RG142FY - UK',
                '-',
                '',
                'Harju maakond, Tallinn',
                'Nõmme linnaosa, Pärnu mnt 388b',
                '11612 - ESTONIA'
            ]
        },
        {
            icon: '/assets/img/redesign/about/location.svg',
            title: 'Contact us',
            lines: [
                'Email:',
                'sales@altheasoft.com',
                '',
                'Phone:',
                '+44 333 224 8250'
            ]
        }
    ];

    trackByTitle(index: number, card: ContactCard): string {
        return card.title;
    }

    trackByIndex(index: number): number {
        return index;
    }

}